import { render, staticRenderFns } from "./StartScene.vue?vue&type=template&id=7207ec84&scoped=true&"
import script from "./StartScene.vue?vue&type=script&lang=js&"
export * from "./StartScene.vue?vue&type=script&lang=js&"
import style0 from "./StartScene.vue?vue&type=style&index=0&id=7207ec84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7207ec84",
  null
  
)

export default component.exports